<template>
    <div id="appBar">
        <v-app-bar
        color="white"
        v-if="show" 
        absolute
        >
            <v-app-bar-nav-icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="check[0]">TAK</v-toolbar-title>
            <v-btn @click="fetchLeague">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            
            <v-btn icon @click="goBack">
                <v-icon>undo</v-icon>
            </v-btn>

            <v-btn icon @click="go('user')">
                <v-icon>account_circle</v-icon>
            </v-btn>

            <v-btn icon @click="logoutUser">
                <v-icon>power_settings_new</v-icon>
            </v-btn>
        </v-app-bar>
        <!-- <Drawer :draw="drawer"  v-model="drawer" temporary/> -->
         <v-navigation-drawer
          absolute
          dark
          v-model="drawer"
          id="drawer">
        <v-list
          dense
          nav
          class="py-0"
        >
          <v-list-item>
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/portraits/men/81.jpg">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Jhony</v-list-item-title>
              <v-list-item-subtitle>Zologowany</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item
            v-for="item in adminMenu"
            :key="item.name"
            link
            @click="go(item.name)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
            v-for="item in menu"
            :key="item.name"
            link
            @click="go(item.name)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
           <v-list-item @click="logoutUser">
              <v-list-item-content>
                  <v-list-item-title>Wyloguj</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>fa-sign-out-alt</v-icon>
              </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>
</template>
<style>
  #drawer{
    z-index: 10000 !important;
  }
</style>
<script>
//import Drawer from './Drawer'
import $api from '../libs/race-app.js'
export default {
    name:'appBar',
    components:{
  //      Drawer
    },
    data(){
        return{
          drawer:false,
          menu:[
              {name:'dashboard',title:'Pulpit',icon:'fa-tachometer-alt'},
              {name:'mycars',title:'Pojazdy',icon:'fa-car'},
              {name:'results',title:'Wyniki',icon:'fa-award'},
              {name:'#',title:'Statystyki',icon:'fa-chart-pie'},
              {name:'tickets',title:'Bilety',icon:'fa-ticket-alt'}
          ],
          adminMenu:[
            {name:'seasoncreator',title:'Seson Creator', icon:'mdi-plus'}
          ],
          show:false, 
          superDupa:"ChUjE!!!" 
        }
    },
    computed:{
      check(){
        return this.$store.state.leagues
      }
    },
    watch:{
      $route(to) {
        if ( to.name != "login") {
          this.show = true;
          this.drawer=false;
          //if (this.drawer) ;
        } else if (to.name == "login") {
          this.show = false;
          this.drawer=false;  
        }
      }
    },
    methods:{
        logoutUser(){
          $api.logout();
          // localStorage.stan = localStorage.login = localStorage.password = localStorage.token = null;
          // this.$store.dispatch('logoutClearData')
          // this.go('login')
        },
        go(pathName){
            return this.$router.push({name:pathName});
        },
        goBack(){
            return this.$router.go(-1);
        },
        fetchLeague(){
          this.$store.dispatch('fetchLeagueData')
        }
    },
}
</script>